import React, { useState } from "react";
import { motion } from "framer-motion";
import { Check, Pill } from "lucide-react";
import { PLANS } from "@/data/content";
import { DownloadModal } from "@/components/landing/DownloadModal";

export const Pricing = () => {
  const [open, setOpen] = useState(false);
  return (
    <section id="pricing" data-testid="pricing-section" className="relative py-24 md:py-32 bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-vitality">Membership Plans</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight mt-4 leading-tight">
            Unlock Your Best Self
          </h2>
          <p className="text-white/60 mt-4 text-lg">
            Start free, upgrade anytime. Cancel whenever. Your evolution, your pace.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {PLANS.map((plan, i) => (
            <motion.div
              key={plan.name}
              data-testid={`plan-${plan.name.toLowerCase()}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`relative rounded-2xl p-8 flex flex-col ${
                plan.highlight
                  ? "bg-charcoal border-2 border-vitality shadow-[0_0_40px_rgba(0,230,118,0.15)] lg:scale-105"
                  : "bg-charcoal border border-white/10"
              }`}
            >
              {plan.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-vitality text-black text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full">
                  Most Popular
                </span>
              )}
              <h3 className="font-heading text-2xl font-bold uppercase tracking-tight">{plan.name}</h3>
              <p className="text-white/50 text-sm mt-1">{plan.tagline}</p>
              <div className="flex items-end gap-1 mt-5">
                <span className="font-heading text-5xl font-black text-white leading-none">{plan.price}</span>
                <span className="text-white/50 mb-1">{plan.period}</span>
              </div>

              <ul className="space-y-3 mt-7 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-white/75">
                    <Check className="w-5 h-5 text-vitality shrink-0 mt-px" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                type="button"
                onClick={() => setOpen(true)}
                data-testid={`plan-cta-${plan.name.toLowerCase()}`}
                className={`mt-8 inline-flex items-center justify-center font-bold uppercase tracking-wider text-sm px-6 py-3.5 rounded-xl transition-colors ${
                  plan.highlight
                    ? "bg-vitality text-black hover:bg-vitality-dim"
                    : "bg-white/5 border border-white/15 text-white hover:border-vitality hover:text-vitality"
                }`}
              >
                {plan.cta}
              </button>
            </motion.div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-3 mt-10 text-white/60">
          <Pill className="w-5 h-5 text-vitality" />
          <p className="text-sm">All Premium & Annual members get <span className="text-vitality font-semibold">25% off all vitamins & supplements</span> at AlphaOmegaVitality.com</p>
        </div>
      </div>

      <DownloadModal open={open} onOpenChange={setOpen} />
    </section>
  );
};
